import { ref } from 'vue';

export default function useErrorHandler() {
  const errorMessage = ref<string | null>(null);
  const errorMessages = ref<string[]>([]);

  const handleError = (errorType: string, message: string | string[], faMessage: string | string[]) => {
    let displayMessage;

    if (faMessage) {
      displayMessage = Array.isArray(faMessage) ? faMessage.join(', ') : faMessage;
    } else if (message) {
      displayMessage = Array.isArray(message) ? message.join(', ') : message;
    } else {
      displayMessage = errorType
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .toLowerCase();
      displayMessage = displayMessage.charAt(0).toUpperCase() + displayMessage.slice(1);
    }

    errorMessage.value = displayMessage;
    errorMessages.value.push(displayMessage);
    return {
      errorMessage,
      errorMessages,
    };
  };
  const clearError = () => {
    errorMessage.value = null;
    errorMessages.value = [];
  };

  return {
    errorMessage,
    handleError,
    clearError,
    errorMessages,
  };
}
